var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.pageData),function(item){return _c('div',{key:item.id},[(item.widget_code == 'textarea' ||
              
              item.widget_code == 'article' ||
              item.widget_code == 'video')?_c(_vm.changCom(item.widget_code),{tag:"component",attrs:{"params":item.params}}):(item.widget_code == 'pcLoft')?_c(item.widget_code,{tag:"component",attrs:{"params":item}}):_c(item.widget_code,{tag:"component",attrs:{"params":item.params}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }